import { Routes, Route } from 'react-router-dom';
import Home from './Components/Pages/Home';
import MySpace from './Components/Pages/MySpace';
import MainList from './Components/MainBannerPage/MainList';
import Search from './Components/Pages/Search';
import Layout from './Components/Pages/Layout';
import Watch from './Components/Pages/Watch';
import Request from './Components/Request/Request';

import AccDeletion from './Components/policy/AccDeletion';
import PrivacyIOS from './Components/policy/PrivacyIOS';
import TermsIOS from './Components/policy/TermsIOS';
import Contact from './Components/policy/ContactUs';
import RaatRangDeletion from './Components/policy/RaatRangDeletion';
import Cinematixdeletion from './Components/policy/Cinematixdeletion';
import Cinematixprivacy from './Components/policy/Cinematixprivacy';
import RaatRangPolicy from './Components/policy/RaatRangPolicy';
import Privacy from './Components/policy/Privacy';
import Promotion from './Components/Pages/promotion';
import AdultPromotion from './Components/Pages/adultpromo';
import AffiliateDashboard from './Components/Pages/AffiliateDashboard';
import AdminChatsPage from './Components/Pages/AdminChats';
import NotFound from './Components/Pages/NotFound';

function App() {
  return (
    <Routes>

      {/* 🔹 PUBLIC ROUTES (NO PREFIX) */}
      <Route path='promotion' element={<Promotion />} />
      <Route path='affiliate' element={<AffiliateDashboard />} />
      <Route path='adult' element={<AdultPromotion />} />
      <Route path='pikchar_data_delete' element={<AccDeletion />} />
      <Route path='raatrang_data_deletion' element={<RaatRangDeletion />} />
      <Route path='pikchar_privacy' element={<Privacy />} />
      <Route path='raatrang_privacy' element={<RaatRangPolicy />} />
      <Route path='privacy_ios' element={<PrivacyIOS />} />
      <Route path='terms_ios' element={<TermsIOS />} />
      <Route path='contact_us' element={<Contact />} />
      <Route path='adminchats20021128' element={<AdminChatsPage />} />
      <Route path='cinematix_privacy_policy' element={<Cinematixprivacy />} />
      <Route path='cinematix_data_delete' element={<Cinematixdeletion />} />

      {/* 🔹 PREFIXED ROUTES → /web2026 */}
      <Route path="/" element={<Layout />}>
        <Route index element={<Home />} />
        <Route path="myspace" element={<MySpace />} />
        <Route path="main-list/:id" element={<MainList />} />
        <Route path="search" element={<Search />} />
        <Route path="request" element={<Request />} />
      </Route>

      {/* 🔹 Watch Routes */}
      <Route path="/watch/:id" element={<Watch />} />
      <Route
        path="/watch/:id/season/:seasonIndex/episode/:episodeIndex"
        element={<Watch />}
      />

      {/* Optional 404 */}
      <Route path="*" element={<NotFound />} />

    </Routes>
  );
}

export default App;
